/**
 * A base class for events which defaults to bubbling and composed
 */
export class NordEvent extends Event {
  constructor(type: string, eventInitDict?: EventInit) {
    super(type, {
      bubbles: true,
      composed: true,
      ...eventInitDict,
    })
  }
}

export function oneEvent<K extends keyof GlobalEventHandlersEventMap>(element: HTMLElement, type: K) {
  return new Promise<GlobalEventHandlersEventMap[K]>((resolve) => {
    element.addEventListener(type, e => resolve(e), { once: true })
  })
}

export function transition(element: HTMLElement) {
  return Promise.race([oneEvent(element, 'transitionend'), oneEvent(element, 'transitioncancel')])
}

export function animation(element: HTMLElement) {
  return Promise.race([oneEvent(element, 'animationend'), oneEvent(element, 'animationcancel')])
}
